import { useState, useLayoutEffect, useEffect } from "react";
import { SmallHeightDivider } from "../../../theme/Styles";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { UpdateAppSubHeaderTitle } from "../../../redux/actions/UiActions";
import { Box, Container, Paper, Typography } from "@mui/material";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import FormRegisterPersonal from "./FormRegisterPersonal";
import FormRegisterCompany from "./FormRegisterCompany";
import COLORS from "../../../theme/Colors";

function Register() {
    const [value, setValue] = useState("1");
    const [isRegistered, setIsRegistered] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const { authenticated } = useSelector((state) => state.authReducer);

    useLayoutEffect(() => {
        dispatch(UpdateAppSubHeaderTitle('')); // Ocultar el banner azul de la cabecera
    }, [dispatch]);

    useEffect(() => {
        if (authenticated) {
            history.push("/app/mi-escritorio");
            return;
        }
    }, [authenticated, history]);

    return (
        <Box className="register-page-bg" sx={{ backgroundColor: "#FFFFFF", minHeight: "90vh", py: { xs: 4, md: 6 } }}>
            <Container maxWidth="lg">
                {!isRegistered && (
                    <>
                        {/* Header Card */}
                        <Box style={{ textAlign: "center", marginBottom: "36px" }}>
                            <Typography 
                                variant="h3" 
                                sx={{ 
                                    fontFamily: "Merriweather, serif", 
                                    fontWeight: 800, 
                                    color: COLORS.secondary, 
                                    fontSize: { xs: "28px", md: "38px" },
                                    mb: 1.5
                                }}
                            >
                                Registro de Usuarios
                            </Typography>
                            <Typography 
                                variant="body1" 
                                sx={{ 
                                    fontFamily: "Roboto, sans-serif", 
                                    color: "#57697F", 
                                    fontSize: "16px", 
                                    maxWidth: "640px", 
                                    mx: "auto" 
                                }}
                            >
                                Cree su cuenta para solicitar, consultar y dar seguimiento a sus trámites turísticos de manera ágil y 100% en línea.
                            </Typography>
                        </Box>

                        {/* Segmented Pill Tab Switcher */}
                        <Box 
                            sx={{ 
                                display: "flex", 
                                justifyContent: "center", 
                                mb: 4 
                            }}
                        >
                            <Box
                                className="register-pill-switcher"
                                sx={{
                                    display: "inline-flex",
                                    backgroundColor: "#FCFCFC",
                                    padding: "6px",
                                    borderRadius: "16px",
                                    border: "1px solid #E1E9EC",
                                    boxShadow: "0 2px 8px rgba(15, 35, 80, 0.03)",
                                    gap: 1
                                }}
                            >
                                <button
                                    onClick={() => setValue("1")}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        border: "none",
                                        outline: "none",
                                        cursor: "pointer",
                                        padding: "10px 24px",
                                        borderRadius: "12px",
                                        fontFamily: "Roboto, sans-serif",
                                        fontWeight: 700,
                                        fontSize: "15px",
                                        backgroundColor: value === "1" ? COLORS.secondary : "transparent",
                                        color: value === "1" ? "#FFFFFF" : "#57697F",
                                        transition: "all 0.2s ease"
                                    }}
                                >
                                    <PersonOutlineIcon style={{ fontSize: "20px" }} />
                                    Registro Ciudadano
                                </button>
                                <button
                                    onClick={() => setValue("2")}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        border: "none",
                                        outline: "none",
                                        cursor: "pointer",
                                        padding: "10px 24px",
                                        borderRadius: "12px",
                                        fontFamily: "Roboto, sans-serif",
                                        fontWeight: 700,
                                        fontSize: "15px",
                                        backgroundColor: value === "2" ? COLORS.secondary : "transparent",
                                        color: value === "2" ? "#FFFFFF" : "#57697F",
                                        transition: "all 0.2s ease"
                                    }}
                                >
                                    <BusinessOutlinedIcon style={{ fontSize: "20px" }} />
                                    Registro Empresa
                                </button>
                            </Box>
                        </Box>
                    </>
                )}

                {/* Main Card Container con fondo #FCFCFC */}
                <Paper
                    elevation={0}
                    sx={{
                        backgroundColor: "#FCFCFC",
                        borderRadius: "24px",
                        border: "1px solid #E1E9EC",
                        boxShadow: "0 12px 32px rgba(15, 35, 80, 0.05)",
                        padding: { xs: 3, sm: 5, md: 6 },
                        maxWidth: "1000px",
                        mx: "auto"
                    }}
                >
                    {value === "1" ? (
                        <FormRegisterPersonal setTab={setValue} setIsRegistered={setIsRegistered} />
                    ) : (
                        <FormRegisterCompany setTab={setValue} setIsRegistered={setIsRegistered} />
                    )}
                </Paper>
            </Container>
        </Box>
    );
}

export default Register;
